import React from 'react';
import { Field } from 'redux-form';
import moment from 'moment';
import { ReduxFormSelect } from '../../../../../../../../components/FormElements';
import { NameDateOption } from '../../Options.styles';
import { useIsWindowWiderThan } from '@common/hooks';
import { gridTheme } from '@utils/grid';

const optionsForPerDate = (options) => {
  const isMobile = !useIsWindowWiderThan(gridTheme.breakpoints.md);
  return options.map((option, index) => ({
    label: isMobile ? (
      `${moment(option.startDate).format('MMM DD')}: ${option.name}`
    ) : (
      <NameDateOption>
        <strong>{option.name}</strong> {moment(option.startDate).format('MMM DD')}
      </NameDateOption>
    ),
    value: index,
  }));
};

export const PerDate = ({ id, options }) => (
  <Field
    component={ReduxFormSelect}
    name={`extras.${id}.option`}
    options={optionsForPerDate(options)}
  />
);
